"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeCheckbox = void 0;
var attribute_checkbox_component_1 = require("./attribute-checkbox.component");
Object.defineProperty(exports, "AttributeCheckbox", { enumerable: true, get: function () { return attribute_checkbox_component_1.AttributeCheckbox; } });
